import api from '../middleware/api'
import { actions } from 'redux-clerk2'
import * as notificationActions from './notifications'

const notifsActions = actions({
  actionPrefix: 'NOTIFICATIONS',
  uidField: 'id',
  actionSettings:{
	  default:{
		  url: `notifications`
		  ,error: {
			  type: 'notification',
			  title: 'Παρουσιάστηκε κάποιο πρόβλημα',
		      message: 'Παρακαλώ ανανεώστε την  εφαρμογή ή δοκιμάστε ξανά αργότερα',
		      kind: 'error'
		  }
	  }
	},
	api: api,
	notificationActions: notificationActions
})

export default notifsActions